import S from './Graph.css'

const purposeIcon = {
  organization : 'fa:fa-object-group ',
  device : 'fa:fa-microchip '
}
const REL_FUNC = {
  oneToOne : ( type, name ) => { return `${type} ${name}() one to one` },
  oneToMany : ( type, name ) => { return `${type}[] ${name}() one to many` },
  manyToOne : ( type, name ) => { return `${type} ${name}() many to one ` },
  manyToMany : ( type, name ) => { return `${type}[] ${name}() many to many ` }
}

const BP_FILL = '#E4E2F7'
const BP_LINE = '#261ACB'
const OTO_FILL = '#FFF2CC'
const OTO_LINE = '#FFD966'
const OTM_FILL = '#DDF7F7'
const OTM_LINE = '#0F9D58'
const MTO_FILL = '#C9DAF8'
const MTO_LINE = '#1C4587'
const MTM_FILL = '#FCE5CD'
const MTM_LINE = '#EC8315'

export default {
  toEr( blueprints, dir = 'TB' ) {
    // console.log( 'blueprints=', blueprints )
    const arr = blueprints
    const lookup = {}
    let str = `%%{ init: { "er": { "layoutDirection" : "${dir}" } } }%%\n erDiagram\n`
    let add = false
    for ( let n = 0; n < arr.length; n++ ) {
      const b = arr[n]
      lookup[b.id] = b
      str += `${b.name.replaceAll( ' ', '' )} {\n`
      for ( let m = 0; m < b.attributes.length; m++ ) {
        const att = b.attributes[m]
        if ( att.type === 'relationship' || att.type === 'parentRelationship' ) {
          continue
        }
        add = true
        str += `  ${att.type} ${att.path.replaceAll( '/', '_' ).replaceAll( '@', '' ).replaceAll( '*', '' )}\n`
      }
      if ( !add ) {
        str += '  no attributes\n'
      }
      str += '}\n'
      
    }

    for ( let n = 0; n < arr.length; n++ ) {
      const b = arr[n]
      for ( let m = 0; m < b.attributes.length; m++ ) {
        const att = b.attributes[m]
        if ( att.type === 'relationship' ) {
          const front = att.relationshipType.startsWith( 'many' ) ? '}|' : '||'
          const end = att.relationshipType.endsWith( 'Many' ) ? '|{' : '||'
          str += `${b.name} ${front}--${end} ${lookup[att.targetBlueprintId]?.name || '???'} : "  ${att.name}  "\n`
        } else if ( att.type === 'parentRelationship' && att.forwardData === true ) {
          str += `${b.name} ||..|| ${lookup[att.sourceBlueprintId]?.name || '???'} : "Forwards Data"\n`
        }
      }
    }
    return str
  },

  toFlow( blueprints, dir = 'TD' ) {
    let linkCount = 0
    const links = { oneToOne : [], oneToMany : [], manyToOne : [], manyToMany : [] }
    const arr = blueprints
    const lookup = {}
    let str = `%%{ init: { "flowchart": { "curve": "basis", "rankSpacing" : 75 } } }%%\n graph ${dir}\n`
    for ( let n = 0; n < arr.length; n++ ) {
      const b = arr[n]
      lookup[b.id] = b
      str += `${blueprintNodeName( b )}\n `
      str += `style B${b.id} fill:${BP_FILL},stroke:${BP_LINE};\n`
      str += `click B${b.id} blueprintNodeClick\n `
    }

    for ( let n = 0; n < arr.length; n++ ) {
      const b = arr[n]
      for ( let m = 0; m < b.attributes.length; m++ ) {
        const att = b.attributes[m]
        if ( att.type === 'relationship' ) {
          const cn = S[`${att.relationshipType}FlowLink`]
          const label = attributeLabel( att, cn )
          str += `B${b.id} --> |${label}| B${att.targetBlueprintId}\n `
          links[att.relationshipType].push( linkCount++ )

        } else if ( att.type === 'parentRelationship' && att.forwardData === true ) {
          str += `B${b.id} -.-> B${att.sourceBlueprintId}\n `
        }
      }
    }

    // const lStyle = { 
    //   oneToOne : 'stroke:#ff3,stroke-width:4px,color:#ffa;',
    //   oneToMany : 'stroke:#ff3,stroke-width:4px,color:#fcf;',
    //   manyToOne : 'stroke:#ff3,stroke-width:4px,color:#cff;',
    //   manyToMay : 'stroke:#ff3,stroke-width:4px,color:#fcc;',
    // }
    // Object.keys( links ).forEach( ( key ) => {
    //   for ( let n = 0; n < links[key].length; n++ ) {
    //     str += `linkStyle ${links[key][n]} ${lStyle[key]}\n`
    //   }
    // } )
    // console.log( str )
    return str
  },

  toGroupFlow( blueprints, dir = 'TD' ) {
    // console.log( 'blueprints=', blueprints )
    const arr = blueprints
    const lookup = {}
    const noRel = []
    const relationships = []
    const rel = { oneToOne : [], oneToMany : [], manyToOne : [], manyToMany : [] }
    let str = `%%{ init: { "flowchart": { "curve": "basis", "rankSpacing" : 75 } } }%%\n graph ${dir}\n`
    for ( let n = 0; n < arr.length; n++ ) {
      const b = arr[n]
      const hasRel = b.attributes.some( att => att.type === 'relationship' )
      lookup[b.name] = b
      lookup[b.id] = b
      const label = blueprintNodeName( b )
      if ( hasRel ) {
        str += `subgraph ${label}\n `
        for ( let m = 0; m < b.attributes.length; m++ ) {
          const att = b.attributes[m]
          if ( att.type === 'relationship' ) {
            const name = `B${b.id}_${att.path}`
            const cn = S[`${att.relationshipType}Group`]
            const label = attributeLabel( att, cn )
            str += `${name}[${label}]\n `
            rel[att.relationshipType].push( name )
            // relationships.push( `B${b.id}_${att.path}` )
          }
        }
        // str += 'end\n '
        str += 'end\n '
        str += `click B${b.id} blueprintNodeClick\n `

      } else {
        str += `subgraph ${label}\n end\n `
        str += `click B${b.id} blueprintNodeClick\n `

        // str += `subgraph ${label}\nno_rel_${n}[none]\nend\n `
        // noRel.push( `no_rel_${n}` )
      }
    }

    for ( let n = 0; n < arr.length; n++ ) {
      const b = arr[n]
      for ( let m = 0; m < b.attributes.length; m++ ) {
        const att = b.attributes[m]
        if ( att.type === 'relationship' ) {
          // const front = att.relationshipType.startsWith( 'many' ) ? '}|' : '||'
          // const end = att.relationshipType.endsWith( 'Many' ) ? '|{' : '||'
          str += `B${b.id}_${att.path} --> B${att.targetBlueprintId}\n `
          if ( att.forwardData ) {
            str += `B${att.targetBlueprintId} -.-> B${b.id}_${att.path}\n `
          }

        } else if ( att.type === 'parentRelationship' && att.forwardData === true ) {
          // str += `B${b.id} -.-> B${att.sourceBlueprintId}\n `
        }
      }
    }
    if ( noRel.length > 0 ) {
      str += 'classDef trans fill:none,stroke:none,font-size:0px,padding:0px\n'
      str += `class ${noRel.join( ',' )} trans\n`
    }
    if ( relationships.length > 0 ) {
      str += 'classDef relationships fill:#ccf,stroke:#559,font-size:12px,margin-bottom:0px\n'
      str += `class ${relationships.join( ',' )} relationships\n`
    }

    str += `classDef oneToOne fill:${OTO_FILL},stroke:${OTO_LINE},rx:4px,ry:4px\n`
    str += `classDef oneToMany fill:${OTM_FILL},stroke:${OTM_LINE},rx:4px,ry:4px\n`
    str += `classDef manyToOne fill:${MTO_FILL},stroke:${MTO_LINE},rx:4px,ry:4px\n`
    str += `classDef manyToMany fill:${MTM_FILL},stroke:${MTM_LINE},rx:4px,ry:4px\n`
    Object.keys( rel ).forEach( ( key ) => {
      if ( rel[key].length > 0 ) {
        str += `class ${rel[key].join( ',' )} ${key}\n`
      }
    } )
    str += `classDef blueprint fill:${BP_FILL},stroke:${BP_LINE}\n`
    str += `class ${blueprints.map( b => `B${b.id}` ).join( ',' )} blueprint\n`

    // console.log( str )
    return str
  },

  toClass( blueprints, dir = 'TB' ) {
    const arr = blueprints
    const lookup = {}
    let str = `classDiagram\n  direction ${dir}\n`
    for ( let n = 0; n < arr.length; n++ ) {
      const b = arr[n]
      lookup[b.id] = b
    }

    for ( let n = 0; n < arr.length; n++ ) {
      const b = arr[n]
      str += `class ${b.name.replaceAll( ' ', '' )} {\n`
      let add = false
      for ( let m = 0; m < b.attributes.length; m++ ) {
        const att = b.attributes[m]
        if ( att.type === 'relationship' ) {
          const tb = lookup[att.targetBlueprintId]
          const type = tb.name || tb.alias || tb.id
          const p = REL_FUNC[att.relationshipType]( type, att.path )
          str += `  ${p}\n`
          add = true
        } else if ( att.type === 'parentRelationship' ) {

        } else {
          str += `  ${att.type} ${att.path}\n`
          add = true
        }
      }
      if ( !add ) {
        str += 'no attributes\n'
      }
      str += '}\n'
    }

    for ( let n = 0; n < arr.length; n++ ) {
      const b = arr[n]
      for ( let m = 0; m < b.attributes.length; m++ ) {
        const att = b.attributes[m]
        let arrow = '-->'
        if ( att.type === 'relationship' ) {
          if ( att.relationshipType === 'oneToOne' ) {
            arrow = att.forwardData ? ' <|-->' : '-->'
          } else if ( att.relationshipType === 'oneToMany' ) {
            arrow = '--*'
          } else if ( att.relationshipType === 'manyToMany' ) {
            arrow = '*--*'
          } else if ( att.relationshipType === 'manyToOne' ) {
            arrow = '*--'
          }
          // let front = att.relationshipType.startsWith( 'many' ) ? '<' : ( att.forwardData ? '' : 'o' )
          // let end = att.relationshipType.endsWith( 'Many' ) ? '"Many"' : 'o'

          str += `${b.name} ${arrow} ${lookup[att.targetBlueprintId]?.name || '???'} : ${att.path}\n`
        } else if ( att.type === 'parentRelationship' && att.forwardData === true ) {
          // str += `${b.name} --|>`
          // str += `${b.name} ||..|| ${lookup[att.sourceBlueprintId]?.name || '???'} : "Forwards Data"\n`
        }
      }
    }
    return str
  },

}

function blueprintNodeName( b ) {
  const icon = purposeIcon[b.purpose] || ''
  return `B${b.id}[<div class='${S.deviceFlowNode}'>${icon}${b.name}</div>]`
}

function attributeLabel( att, cn ) {
  const icon = att.forwardData === true ? 'fa:fa-upload ' : ''
  return `<div class='${cn}'>${icon}${att.name || att.path}</div>`
}
